<template>
    <div id="mPanel5"
         style="height:100%">
        <el-main class="right-content">
            <m-search-list :popPrefix="popPrefix"
                           ref="searchList"
                           :searchId="searchId"
                           :list="config.searchList"
                           :pickerConfig='pickerConfig'
                           :searchTotalTitle="searchTotalTitle"
                           :optionNum="optionNum"
                           :configurationUrl="configurationUrl"
                           :longPrefix="longPrefix"
                           :advancePrefix="advancePrefix"
                           :searchSetTitle="searchSetTitle"
                           @onSearchChange="searchChange"
                           @search-list-change="searchListChange"
                           @searchSet-change="searchSetchange"
                           @tableAdvance="tableAdvance">
                <span slot="search-list-advance-right">
                    <slot name="search-list-advance-right"></slot>
                </span>
                <!-- 列配置、导出 -->
                <div slot="table-module-btn"
                     class="btn-box">
                    <!-- 外层调用 -->
                    <slot name="table-module-btn"></slot>
                    <!-- 列配置 -->
                    <el-tooltip v-if="config.configuration?false: true"
                                class="item allocation-box"
                                effect="dark"
                                content="列配置"
                                placement="bottom">
                        <el-button size="mini"
                                   class="el-icon-setting"
                                   @click="getTitleList"></el-button>
                    </el-tooltip>
                    <el-dialog :visible.sync="showModal"
                               title="列配置"
                               @close="dialogClose">
                        <configuration :checkedList="checkedList"
                                       :selectAllColumns="config.table.columns"
                                       ref="dialog"
                                       @getTableConfigList="getTableConfigList"
                                       @tableConfigClose="tableConfigClose"
                                       :columnNum='columnNum'></configuration>
                    </el-dialog>
                </div>
            </m-search-list>
            <div class="all-table">
                <div class="all-table-right"
                     ref="allTableRight">
                    <div style="height:100%"
                         slot="map">
                        <slot name="map"></slot>
                    </div>
                </div>
            </div>
        </el-main>

    </div>
</template>
<script>
import mSearchList from '@/modules/transport/otp/components/mulitPanel/mSearchList';
import configuration from '@/components/awesome/page/mPanel3/configuration-list';
import getList from '@/components/awesome/page/mPanel3/api';

import { mapGetters } from 'vuex';

export default {
    name: 'mPanel',
    components: { mSearchList, configuration },
    computed: {
        ...mapGetters(['menus'])
    },
    data () {
        return {
            inputData: {
                vehicleCard: '',
                dispatchNo: '',
                driver: ''
            },
            sourceCurrent: '',
            showModal: false,
            tableList: '',
            settingColumns: this.config.table.columns,
            checkedList: '',
            pageState: true,
            popPrefix: this.config.popPrefix ? this.config.popPrefix : '/api-mdm/dictionaryDetail/dict',
            advancePrefix: this.config.advancePrefix ? this.config.advancePrefix : '/api-mdm',
            longPrefix: this.config.longPrefix ? this.config.longPrefix : '/api-gwms/es/comboBox',
            configurationUrl: this.config.configurationUrl ? this.config.configurationUrl : '/api-auth',
            resourceCode: ''
        };
    },
    props: {
        pickerConfig: Object,
        config: Object,
        pageID: String,
        searchId: String,
        optionNum: String,
        loading: {
            type: Boolean,
            default () {
                return true;
            }
        },
        searchTotalTitle: {
            type: Array,
            default () {
                return [];
            }
        },
        searchSetTitle: {
            type: Array,
            default () {
                return [];
            }
        },
        columnNum: Number,
        mulSourceSel: Boolean
    },
    methods: {
        deepMenu (node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    for (let i = 0; i < childrens.length; i++) {
                        if (childrens[i].frontUrl === this.$route.path) {
                            this.resourceCode = childrens[i].resourceCode;
                        } else {
                            this.deepMenu(childrens[i]);
                        }
                    }
                }
            }
        },
        // 搜索内容变化
        searchChange (data) {
            this.$emit('searchChange', data);
        },
        getTableConfigList (tabelConfigList, tabelConfigName) {
            if (this.config.configuration) {
            } else {
                this.showModal = false;
                const pramas = {
                    'configName': tabelConfigName,
                    'configNameCn': tabelConfigList,
                    'subjectType': this.pageID,
                    'moduleCode': 'RE1202112220012' // 因为没有菜单，所以默认用调度中心的菜单编码
                };
                getList.post(this.configurationUrl, pramas).then(() => { });
                this.tableList = tabelConfigList;
                this.$emit('getTableColumnConf', this.tableList);
            }
        },
        tableConfigClose () {
            this.showModal = false;
        },
        dialogClose () {
            this.$refs.dialog.initData();
        },
        // 获取表格头保存参数
        async getTableTitle () {
            if (this.config.configuration) {
                return new Promise((resolve) => {
                    resolve(() => {
                        this.checkedList = '';
                    });
                });
            } else {
                const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
                await this.deepMenu(menu);
                let allColumns = [];
                let allColumnsprop = [];
                this.config.table.columns.map((item, index) => {
                    if (this.columnNum && index >= this.columnNum) {
                    } else {
                        allColumns.push(item.label);
                        allColumnsprop.push(item.prop);
                    }
                });
                allColumns = allColumns.join(',');
                allColumnsprop = allColumnsprop.join(',');
                const pramas = {
                    'configName': allColumnsprop,
                    'configNameCn': allColumns,
                    'moduleCode': 'RE1202112220012',
                    'subjectType': this.pageID
                };
                return getList.get(this.configurationUrl, pramas).then(data => {
                    if (data.data) {
                        this.checkedList = data.data.configNameCn;
                    } else {
                        this.checkedList = allColumns;
                    }
                }).catch(() => {
                    this.checkedList = allColumns;
                });
            }
        },
        initTitleList () {
            let laberString = [];
            if (this.checkedList === '') {
                this.config.table.columns.map(data => {
                    laberString.push(data.label);
                });
                laberString = laberString.join(',');
                this.tableList = laberString;
                this.$emit('getTableColumnConf', this.tableList);
            } else {
                this.tableList = this.checkedList;
                this.$emit('getTableColumnConf', this.tableList);
            }
        },
        getTitleList () {
            return this.getTableTitle().then(() => {
                this.showModal = true;
            });
        },
        // 表格内高级搜索
        tabAdvancedSearch (data, item, type, searchData) {
            this.$refs.searchList.detaliSearch(data, item, type, searchData);
        },
        tableAdvance (prop, advanceCode, data, code) {
            this.$refs.table.ruleForm[prop] = data;
            this.$refs.table.ruleForm[advanceCode] = code;
        },
        searchListChange(config, data) {
            this.$emit('search-list-change', config, data);
        },
        // 高级的搜索条件不同步外面的搜索条件的，解决值改变不会触发
        searchSetchange (data) {
            this.$emit('searchSet-change', data);
        },
        initActiveChange () {
            this.sourceCurrent = '';
            this.inputData = {};
        }
    },
    mounted () {
        this.getTableTitle().then(() => {
            this.initTitleList();
        });
    }
};
</script>
<style lang="less">
@import './mpanel.less';
.table-lists {
    overflow: auto;
    background: #fff;
    color: #333;
    width: 260px;

    .list-details {
        cursor: pointer;
        font-size: 14px;
        color: #333;
        overflow: hidden;
        padding: 5px 10px;
        line-height: 1.5;
        word-break: break-all;
        &:last-child {
            margin-bottom: 20px;
        }
    }
    .el-main {
        height: 100%;
    }
    .el-scrollbar {
        height: 100%;
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
        .el-scrollbar__bar.is-vertical {
            width: 10px;
            border-radius: 5px;
        }
        .el-scrollbar__bar.is-horizontal {
            height: 10px;
            border-radius: 5px;
            text-align: center;
        }
    }
    .active {
        color: #00bcbf;
    }
    .noneLi {
        text-align: center;
        font-size: 12px;
        margin-bottom: 10px;
    }
}
</style>
